import React from 'react';
import SubscriptionBanner from './SubscriptionBanner';

export default function AuthenticatedLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <SubscriptionBanner />
      <div className="flex-1">
        {children}
      </div>
    </div>
  );
}
